<nav id="admin-header" class="navbar navbar-light">
  <div class="container-fluid">
    <div class="d-flex align-items-center justify-content-start">
      <button (click)="showSideBar()" class="btn btn-primary" id="sidebarToggle"><i class="fa-regular fa-arrow-left-to-line"></i></button>
      <h1 class="mb-0 me-3"> {{headerText}}</h1>
    </div>
    <div class="d-flex align-items-center justify-content-end">
      <!-- notifications -->
      <div class="dropdown me-2">
        <!-- <button class="btn btnHeader" type="button" id="notificationDrop" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="fa-regular fa-bell"></i>
        </button> -->
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="notificationDrop">
          <li><a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#userModal" href="#"><i class="fa-light fa-pencil fa-fw"></i> Edit</a></li>
          <li><a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#userModal" href="#"><i class="fa-light fa-pencil fa-fw"></i> test</a></li>
          <li><a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#userModal" href="#"><i class="fa-light fa-pencil fa-fw"></i> test</a></li>
          <li><a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#userModal" href="#"><i class="fa-light fa-pencil fa-fw"></i> test</a></li>
          <li><a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#userModal" href="#"><i class="fa-light fa-pencil fa-fw"></i> test</a></li>
          <li><a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#userModal" href="#"><i class="fa-light fa-pencil fa-fw"></i> test</a></li>
          <li><a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#userModal" href="#"><i class="fa-light fa-pencil fa-fw"></i> test</a></li>
        </ul>
      </div>
      <!-- user -->
      <div class="dropdown">
        <button class="btn btnHeader px-3 dropdown-toggle" type="button" id="userDrop" data-bs-toggle="dropdown" aria-expanded="false">
          <span class="userIcon me-2"><i class="fa-regular fa-user"></i></span> <span class="me-2">{{myAdmin.fullName}}</span>
        </button>
        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="userDrop">
          <li><a class="dropdown-item" (click)="EditMyProfile()" href="javascript:void(0);"><i class="fa-light fa-pencil fa-fw"></i> Edit Profile</a></li>
          <li><a class="dropdown-item" (click)="logout()" href="javascript:void(0);"><i class="fa-light fa-power-off fa-fw"></i> Logout</a></li>
        </ul>
      </div>
    </div>
  </div>
</nav>
